import React from 'react';
import { Alert, Button } from 'react-bootstrap';

import { GetExamBlockDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface AlertExamBlockProps {
  activeBlock: GetExamBlockDto | null;
  onUnblock: () => void;
  onEdit: () => void;
}

export const AlertExamBlock: React.FC<AlertExamBlockProps> = ({
  activeBlock,
  onUnblock,
  onEdit,
}) => {
  if (!activeBlock) {
    return null;
  }

  return (
    <Alert
      variant="danger"
      className="mb-2 py-2 px-3 d-flex align-items-center justify-content-between"
    >
      <div>
        <strong>Badanie zablokowane</strong>
        {activeBlock.reason && (
          <span className="ms-2">{activeBlock.reason}</span>
        )}
      </div>
      <div className="d-flex gap-2">
        <Button variant="outline-danger" onClick={onEdit}>
          Edytuj blokadę
        </Button>
        <Button variant="outline-danger" onClick={onUnblock}>
          Odblokuj
        </Button>
      </div>
    </Alert>
  );
};
